import { useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  Box,
  Typography,
  Paper,
  Stack,
  Collapse,
  Checkbox,
  FormControlLabel,
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import SportsMartialArtsIcon from "@mui/icons-material/SportsMartialArts";
import KeyIcon from "@mui/icons-material/Key";

export default function Registration() {
  const navigate = useNavigate();

  const [mode, setMode] = useState<"new" | "existing" | null>(null);

  const [accepted, setAccepted] = useState(false);
  const [registrationCode, setRegistrationCode] = useState("");

  const [dialogOpen, setDialogOpen] = useState(false);
  const [generatedCode, setGeneratedCode] = useState("");

  const generateCode = () => {
    // TODO : remplacer par appel API
    const code = crypto.randomUUID();

    setGeneratedCode(code);
    setDialogOpen(true);
  };

  const goToManageRegistration = () => {
    navigate("/manage-registration");
  };

  return (
    <Box
      sx={{
        maxWidth: 900,
        mx: "auto",
        px: 3,
        py: 4,
      }}
    >
      <Typography
        variant="h4"
        fontWeight="bold"
        gutterBottom
      >
        Gérer mes inscriptions
      </Typography>

      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ mb: 4 }}
      >
        Open International de Sambreville
      </Typography>

      <Stack spacing={2}>
        <Paper
          elevation={mode === "new" ? 4 : 2}
          onClick={() => setMode("new")}
          sx={{
            p: 3,
            cursor: "pointer",
            border:
              mode === "new"
                ? "2px solid #d50000"
                : "2px solid transparent",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: 2,
              alignItems: "center",
            }}
          >
            <SportsMartialArtsIcon
              color="primary"
              fontSize="large"
            />

            <Box>
              <Typography variant="h6">
                Première inscription
              </Typography>

              <Typography color="text.secondary">
                C'est la première fois que j'inscris un judoka
                à ce tournoi.
              </Typography>
            </Box>
          </Box>
        </Paper>

        <Collapse in={mode === "new"}>
          <Paper
            elevation={1}
            sx={{
              p: 3,
              mb: 2,
              backgroundColor: "background.default",
            }}
          >
            <Typography
              variant="h6"
              gutterBottom
            >
              Première inscription
            </Typography>

            <FormControlLabel
              control={
                <Checkbox
                  checked={accepted}
                  onChange={(e) =>
                    setAccepted(e.target.checked)
                  }
                />
              }
              label="J'accepte que mes données soient utilisées et stockées dans le cadre exclusif de l'Open International de Sambreville."
            />

            <Button
              variant="contained"
              color="error"
              disabled={!accepted}
              sx={{ mt: 2 }}
              onClick={generateCode}
            >
              Générer mon code d'inscription
            </Button>
          </Paper>
        </Collapse>

        <Paper
          elevation={mode === "existing" ? 4 : 2}
          onClick={() => setMode("existing")}
          sx={{
            p: 3,
            cursor: "pointer",
            border:
              mode === "existing"
                ? "2px solid #d50000"
                : "2px solid transparent",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: 2,
              alignItems: "center",
            }}
          >
            <KeyIcon
              color="primary"
              fontSize="large"
            />

            <Box>
              <Typography variant="h6">
                J'ai déjà un code
              </Typography>

              <Typography color="text.secondary">
                Consulter ou modifier mes inscriptions.
              </Typography>
            </Box>
          </Box>
        </Paper>

        <Collapse in={mode === "existing"}>
          <Paper
            elevation={1}
            sx={{
              p: 3,
              backgroundColor: "background.default",
            }}
          >
            <Typography
              variant="h6"
              gutterBottom
            >
              Merci de fournir votre code d'inscription
            </Typography>

            <TextField
              fullWidth
              label="Code d'inscription"
              value={registrationCode}
              onChange={(e) =>
                setRegistrationCode(e.target.value)
              }
              sx={{ mb: 3 }}
            />

            <Button
              variant="contained"
              color="error"
              disabled={!registrationCode.trim()}
              onClick={goToManageRegistration}
            >
              Gérer mes inscriptions
            </Button>
          </Paper>
        </Collapse>
      </Stack>

      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          Votre code d'inscription
        </DialogTitle>

        <DialogContent>
          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: "1.25rem",
              mb: 3,
            }}
          >
            {generatedCode}
          </Typography>

          <Typography>
            Conservez précieusement ce code.
          </Typography>

          <Typography sx={{ mt: 2 }}>
            Il vous permettra de gérer vos inscriptions
            ultérieurement.
          </Typography>
        </DialogContent>

        <DialogActions sx={{ p: 3 }}>
          <Button
            onClick={() =>
              navigator.clipboard.writeText(generatedCode)
            }
          >
            Copier le code
          </Button>

          <Button
            variant="contained"
            color="error"
            onClick={goToManageRegistration}
          >
            Gérer mes inscriptions
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}